<template>
  <div style="max-width:600px; margin: 0 auto;min-height:90vh;">
    <v-card v-if="user" flat>
      <v-container style="padding-top:0px;padding-bottom:0">
        <v-layout row wrap>
          <v-flex xs6 style="text-align:left;color:#999;padding-top:10px;">{{user.join | displayDate}}登録</v-flex>
          <v-flex xs6 v-if="isOwner" style="text-align:right">
            <v-btn @click="onEdit" small round outline color="primary">
              <v-icon small>edit</v-icon>プロフィールを編集する
            </v-btn>
          </v-flex>        
        </v-layout>
        <div style="width:100%;text-align:left;margin-bottom:16px;">
          <!-- <v-avatar size="50"><v-img v-if="!isImageLoading" :src="user.imageurl"/></v-avatar> -->
          <v-avatar size="48"><v-img :src="user.imageurl" :alt="`${user.displayName}さんアイコン画像`"/></v-avatar>
          <span class="title" style="margin-left:10px;vertical-align:middle;font-weight:bold;">{{user.displayName}}</span>
        </div>
        <v-layout row wrap v-if="user.description" style="margin-bottom:16px;">
          <v-flex md2 xs12 class="formElementLabel">自己紹介</v-flex>
          <v-flex md10 xs12 style="text-align:left;font-weight:bold;"
            v-html="$options.filters.changeBr(user.description)"
          >
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="user.url || user.twitter">
          <v-flex md2 xs12 class="formElementLabel">SNS／ホームページ</v-flex>
          <v-flex md10 xs12 style="text-align:left;">
            <span v-if="user.twitter" style="margin-right:16px;">
              <a :href="`https://twitter.com/${user.twitter.username}`" target="_blank">twitter</a>
            </span>
            <span v-if="user.url" style="margin-right:10px;white-space: nowrap;overflow-x:scroll;">
              <a :href="user.url" target="_blank">{{user.url}}</a>
            </span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-tabs v-model="tab" slider-color="primary" show-arrows grow style="margin-top:5px;">
        <v-tab key="tab1" href="#posts">カラログ</v-tab>
        <!-- <v-tab key="tab2" href="#tabetai">カライイネ</v-tab> -->
        <v-tab key="tab3" href="#rank">辛さ比較</v-tab>
        <!-- <v-tab key="tab4" href="#follow">フォロー</v-tab> -->
        <v-tabs-items style="padding:10px">
          <v-tab-item key="tab1" value="posts" style="padding:0 5px;">
            <review-card
              v-for="(p, id) in posts"
              :post=p :key=id
              :showFood=true
              @onReviewCardClick=onReviewCardClick
              @onMessage=onMessage
              style="margin-bottom:16px;"
            ></review-card>
            <p v-show="posts_saved.length>0" style="text-align:center;">
              <v-btn @click="showPosts" color="primary" dark large>もっと見る</v-btn>
            </p>
          </v-tab-item>
          <!-- <v-tab-item key="tab2" value="tabetai">
            <food-card-min
              v-for="(t, id) in tabetai" :key=id
              :name="t.name"
              :imageurl="tabetai_image[id]"
              :label="`${$options.filters.displayDate(t.timestamp)} カライイネ！`"
              @onFoodCardMinClick="$router.push({name: 'searchFoodDetail', params: {id: t.id}})"
              style="margin:0 10px 10px 10px;"
            ></food-card-min>
            <div v-if="tabetai.length===0" style="text-align:center;">
              <p>{{user.displayName}}さんのカライイネはありません</p>
            </div>
          </v-tab-item> -->
          <v-tab-item key="tab3" value="rank" style="padding:0 10px 10px 10px;">
            <div v-if="rank.length>0">
              <div v-if="isOwner" style="text-align:right;">
                <v-btn
                  @click="$router.push({name: 'RankEdit'})"
                  dark round color="primary" small
                >
                  <v-icon small>edit</v-icon>ランキングを編集する
                </v-btn>
              </div>
              <food-card-rank
                v-for="(t, id) in rank" :key=id
                :rank=t
                :label="`${id+1}位`"
                style="margin-bottom:5px;"
              ></food-card-rank>
              <div v-if="isOwner">
                <v-btn 
                  @click="$router.push({name: 'RankEdit'})"
                  dark round color="primary" small block
                >
                  <v-icon small>edit</v-icon>ランキングを編集する
                </v-btn>
              </div>
            </div>
            <div v-else>
              辛さ比較の登録はありません
              <v-btn v-if="isOwner" :to="{name: 'karasaInit'}" outline block color="primary"><v-icon>add</v-icon>辛さ比較を登録</v-btn>
            </div>
          </v-tab-item>
          <!-- <v-tab-item key="tab4" value="follow">
            フォロー
          </v-tab-item> -->
        </v-tabs-items>
      </v-tabs>
    </v-card>
    <div v-show="isLoading" style="text-align:center;height:100x;padding-top:150px;">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
import ReviewCard from '@/components/card/ReviewCard.vue'
// import FoodCardMin from '@/components/card/FoodCardMin.vue'
import FoodCardRank from '@/components/card/FoodCardRank.vue'
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'

// @ is an alias to /src
export default {
  name: 'MyPageTop',
  data () {
    return {
      isLoading: false,
      uid: '',
      user: undefined,
      posts: [],
      posts_saved: [],
      maxCount: 10,
      isImageLoading: true,
      tab: null,
      tabetai_image: [],
      rank: [],
      tabetai: [],
      rank_image: [],
      isPostLoaded: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    loginUid () {
      return this.$store.state.user.uid
    },
    isOwner () {
      if (this.loginUid === this.uid) return true
      return false
    },
    // tabetai () {
    //   return this.$store.state.tabetai
    // },
    headerUserName () {
      if (this.user) {
        return this.user.displayName
      }
      return ''
    }
  },
  watch: {
    'tab' (after) {
      if (after === 'posts') {
        this.getPosts()
      }
    }
  },
  filters: {
    displayDate (value) {
      let date = new Date()
      if (value.seconds) {
        date.setTime(value.seconds * 1000)
      } else {
        date.setTime(value)
      }      
      return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`
    },
    changeBr: function (value) {
      return value.replace(/\r?\n/g, '<br>')
    }
  },
  created () {
    this.uid = this.$route.params.id
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      if (this.$route.query.p) {
        let p = this.$route.query.p
        if (p === 'rank') {
          this.tab = 'rank'
        }
      }
      this.getUser()
      if (this.tab !== 'rank') {
        this.getPosts()
      }
      this.getRank()
      // this.getTabetai()
      window.scrollTo(0, 0)
    },
    async getUser() {
      this.isLoading = true
      let response = await db.collection('user').doc(this.uid).get()
      this.user = response.data()
      this.$emit('updateHead')
      this.user.imageurl = getImageUrl.get('profile', this.uid, this.user.photoURL)
      this.isImageLoading = false

      if (this.isOwner) {
        // Storeの更新
        this.$store.commit('setDisplayName', this.user.displayName)
        this.$store.commit('setImageurl', this.user.imageurl)
      }
      this.isLoading = false
    },
    async getPosts() {
      if (this.isPostLoaded) return
      this.isLoading = true
      let response = await db.collection('post').where('user.uid', '==', this.uid).orderBy('timestamp', 'desc').get()
      this.posts_saved = []
      response.forEach((doc) => {
        let post = doc.data()
        post.id = doc.id
        this.posts_saved.push(post)
      })
      this.showPosts()
      this.isLoading = false
      this.isPostLoaded = true
    },
    showPosts () {
      let counter = 0
      let length = this.posts_saved.length
      for (let i = 0; i < length; i++) {
        let post = this.posts_saved.shift()
        this.posts.push(post)
        counter++
        if (counter >= this.maxCount) {
          break
        }
      }
    },
    onReviewCardClick (post) {
      this.$router.push({name: 'searchReviewDetail', params: {id: post.id}})
    },
    onEdit () {
      this.$store.commit('setTempUser', this.user)
      this.$router.push({name: 'UserProfileEdit'})
    },
    async getTabetaiImage () {
      for (let i = 0; i < this.tabetai.length; i++) {
        let url = getImageUrl.get('food_thumbs', this.tabetai[i].id, this.tabetai[i].imageurl)
        this.tabetai_image.push(url)
      }
    },
    async getRank () {
      let response = await db.collection('rank').where('user.uid', '==', this.uid).get()
      let rankData = undefined
      response.forEach((doc) => {
        rankData = doc.data()
      })
      if (rankData) {
        for (let i = 0; i < rankData.foods; i++) {
          let url = getImageUrl.get('food_thumbs', rankData.foods[i].id, this.rankData.foods[i].images[0])
          rankData.foods[i].imageurl = url
        }
        this.rank = rankData.foods
      }
    },
    async getTabetai () {
      let response = await db.collection('tabetai').doc(this.uid).get()
      let tabetaiData = response.data()
      if (tabetaiData) {
        this.tabetai = tabetaiData.list
        this.getTabetaiImage()
      }
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  components: {
    ReviewCard,
    // FoodCardMin,
    FoodCardRank
  },
  head: {
    title () {
      return {
        inner: `${this.headerUserName}さんのページ`,
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミグルメサイトの初期登録ページです'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  }
}
</script>

<style>
  .formElementLabel {
    text-align: left;
    color:#888;
  }
  .v-tabs__item {
    font-size: 14pt;
    font-weight:bold;
  }
  .v-tabs__item--active {
    color: #f44336 !important;
    font-weight: bold;
  }
</style>
>